var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#916ede",
    opacity: 1,
    "data-original": "#03b8ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M8.7 12.3 10 8.7l3.4 9.1c.1.3.4.6.7.6.3 0 .6-.2.7-.6l1.8-5h2.6c.5 0 .8-.3.8-.8s-.3-.9-.8-.9H15.7s-.3.1-.4.4L14 15.1l-3.4-9c-.2-.4-.6-.6-1-.5-.2.1-.3.3-.4.5l-1.8 5H4.8c-.5 0-.8.3-.8.8s.3.8.8.8H8.3c.3 0 .4-.4.4-.4z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRate);
export default __webpack_public_path__ + "static/media/heart-rate.21603e1713afb1da544bce356548242c.svg";
export { ForwardRef as ReactComponent };